import axios from "axios";
import {BASE_URL} from '../global'

const apiPortal = axios.create({
    baseURL: BASE_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const promiseGestaoConteudo = apiPortal.post("/notafiscal-ws/servico/gestao-conteudo/")

export default {
    getConteudo() {
        console.log("Chamando o serviço de Gestão de Conteúdo !!!")
        return promiseGestaoConteudo;
    },

    getBundle(labelMessage) {
        console.log("Chamando o serviço de Bundle !!!")
        return apiPortal.post("/notafiscal-ws/servico/gestao-conteudo/bundle/", labelMessage)
    }
};
